define('evertrue',[
    "jquery",
    "underscore",
    "backbone",
    "env",
    "helpers/url-helper",
    "amplify",
    "fastButton",
    "bootstrapTransition",
    "bootstrapAlert",
    "bootstrapModal",
], function EverTrueFactory ( $, _, Backbone, env, urlHelper) {
    // amplify, fastButton, and the bootstrap dependencies need to be loaded (to have their global effects)
    // before app boot but don't have return valuese

    // Initalize Environment Global Config Setup
    window.EverTrue = window.EverTrue || {};
    window.EverTrue.conf = env.configure();

    // use mustache style templating
    _.templateSettings = {
        interpolate : /\{\{(.+?)\}\}/g
    };

    // Put application wide code here
    var conf = window.EverTrue.conf || {};
    // Set evertrue api version
    conf.ver = '1.0';

    // function to allow Jquery to easily serialize form data into an object
    $.fn.serializeObject = function ()
    {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function() {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    // function to allow Jquery to easily serialize form data into an object
    // this differs from serializeObject because it will nest values as prop.key
    $.fn.serializeNestedObject = function () {
        var object = {},
            collection = this.serializeArray(),
            grouped = {};

        grouped = _.groupBy(collection, function(model){ return model.name; });
        collection = _.map(grouped, function(group, name) {
            if (group.length > 1) {
                return {name: name, value: _.pluck(group, "value")};
            } else {
                return _.first(group);
            }
        });

        // name.descriptions -> {name: {description: {} }}
        // last value in properties then set = model.value
        _.each(collection, function(model){
            var obj = {},
                tmp = obj,
                properties = model.name.split("."),
                key = _.first(properties);

            properties.shift();
            if (properties.length) {
                _.each(properties, function(prop){
                    if (prop == _.last(properties)) {
                        tmp = tmp[prop] = model.value;
                    } else {
                        tmp = tmp[prop] = {};
                    }
                });
                object[key] = object[key] || {};
                $.extend(true, object[key], obj);
            } else {
                object[key] = model.value;
            }

        });

        return object;
    };


    // Call on body element and pass in selected element selector
    // For autocomplete dropdowns to scroll to highlighted element in list
    $.fn.scrollToHighlight = function(selector) {
        var $body, $highlighted, high_bottom, high_top, maxHeight, ref, visible_bottom, visible_top;
        $body = $(this);
        $highlighted = $body.find(selector);
        maxHeight = parseInt($body.css("maxHeight"), 10);
        visible_top = $body.scrollTop();
        visible_bottom = maxHeight + visible_top;
        high_top = ((ref = $highlighted.position()) != null ? ref.top : void 0) + $body.scrollTop();
        high_bottom = high_top + $highlighted.outerHeight();
        if (high_bottom >= visible_bottom) {
            return $body.scrollTop((high_bottom - maxHeight) > 0 ? high_bottom - maxHeight : 0);
        } else if (high_top < visible_top) {
            return $body.scrollTop(high_top);
        }
    };

    // helpers pulled from Backbone
    // Helper function to get a value from a Backbone object as a property
    // or as a function.
    window.getValue = function ( object, prop ) {
        if (!(object && object[prop])) return null;
        return _.isFunction(object[prop]) ? object[prop]() : object[prop];
    };

    // Throw an error when a URL is needed, and none is supplied.
    window.urlError = function () {
        throw new Error('A "url" property or function must be specified');
    };

    window.url = function(urlRoot_param, urlOverride, type) {
        //TODO - needs a major overhaul
        var urlOverride = urlOverride || {};
        var urlRoot = urlRoot_param || this.urlRoot;
        if (_.isFunction(urlRoot)){
            urlRoot = urlRoot();
        }
        var extraParams = {},
            addSessionIdentifier = (EverTrue.Session && EverTrue.Session.get('id')) ? true : false;

        //if changing organizations from dropdown, dont need session identifier
        if (urlOverride.switch_oid) {
            addSessionIdentifier = false;
        }

        // Don't add auth params to legacy dna endpoint "dna"
        var add_dna_auth = (urlRoot != "dna" || (urlRoot == "dna" && (type == "PUT" || type == "POST")));
        if (addSessionIdentifier && add_dna_auth) {
            if ((EverTrue.Session.get('token')) &&
                ((urlRoot != "auth/session") || ((urlRoot == "auth/session") && (!urlOverride.params)))) {
                extraParams.auth = EverTrue.Session.get('token');
                extraParams.auth_provider = "evertrueauthtoken";
            }
            if (EverTrue.Organization.get('id')) {
                extraParams.oid = EverTrue.Organization.get('id');
            }
        }
        // allways add the app_key
        extraParams.app_key = EverTrue.conf.app_keys.console;

        var override = ( typeof this.urlOverride != 'undefined' ) ? this.urlOverride : urlOverride;

        // Can I remove this oid check section?
        var oid;
        if (override.oid) {
            oid = override.oid;
        } else if (urlOverride.switch_oid) {
            oid = urlOverride.switch_oid;
        } else {
            oid = EverTrue.Organization.get("id");
        }
        if ((urlRoot.indexOf("login") < 0) &&
            (urlRoot.indexOf("auth/session") < 0) &&
            (urlRoot.indexOf("auth/organization") < 0) &&
            (urlRoot.indexOf("skiff") < 0)) {
            if (!oid && EverTrue.alertView) {
                EverTrue.alertView.alert("error", {message: "Organization is not set"});
            }
        }

        //if access key is set, need to add this for creating a new org
        if (override.access_key) {
            extraParams.access_key = override.access_key;
        }

        //  Prepare the parameters
        var params = _.isFunction(this.params) ? this.params() : ( this.params || {} );

        // get the endpoint form the model or collection urls
        var endpoint = urlRoot;
        if (params.modifier) endpoint = endpoint + '/' + params.modifier;
        if ( _.isFunction(this.isNew) && !this.isNew() ) {
            endpoint = endpoint + '/' + encodeURIComponent(this.id);
        }

        params = _.extend(params, extraParams);
        // If a new org is being created, the oid will be replaced with the override params oid
        if (override.params) {
            params = _.extend(params, override.params);
        }

        // clean the paramaters
        for (var key in params) {
            if (params[key] === null) {
                delete params[key];
            }
        }

        // Build the full url
        // Create and append a query string from a params object
        endpoint += (endpoint.indexOf('?') != -1 ? '&' : '?') + $.param(params);
        var urlBase = conf.apiBase;
        if (urlRoot == "dna") {
            urlBase += conf.ver + '/' + EverTrue.Organization.get("slug") + '/';
        }
        return  urlBase + endpoint;
    };

    window.getUrl = window.url;

    var EverTrue = {
        // default configuration strings
        $el: $('#app'),
        conf: conf,
        // add a gloabl event aggregator
        vent : _.extend({}, Backbone.Events),
        api: function(ep, op, con) {
            var promise = $.Deferred();
            var view = this;
            var context, options, endpoint;
            // make backwards compatible for transition
            if ( typeof ep === "object" ) {
                context = op;
                options = ep;
                endpoint = undefined;
            } else {
                endpoint = ep;
                options = op;
                context = con;
            }

            options = options || {};
            options.headers = options.headers || {};

            if (_.isFunction(context)){
                options.success = context;
                context = undefined;
            }
            // translate params to the data
            if (options.params) {
                options.data = options.data || {};
                options.data = _.extend(options.params, options.data);
            }

            // build the url
            // translate url to endpoint
            if (options.url) endpoint = options.url;
            var urlOverride = options.urlOverride || {};
            options.url = window.getUrl(endpoint, urlOverride, options.type);

            // If search v2 and there's data, default to POST
            if (options.data && endpoint && (endpoint.indexOf("search/v2") > -1 || endpoint.indexOf("v2/search") > -1)) {
                options.type = "POST";
            }

            // make sure to stringify post data
            if (options.type === 'POST' || options.type === 'PUT'){
                options.data = JSON.stringify( options.data );


                // if we are updating contacts we need different headers
                // and options for some reason
                if (endpoint && endpoint.split('/')[0] === 'contacts'){
                    options.headers["ET-Update-Source"] = "CONSOLE";
                    options.contentType = "application/json";
                } else {
                    options.headers["Accept"] = "application/json";
                }
            }

            // set up the callbacks and triggers
            var success = options.success;

            options.beforeSend = function (xhr, options) {
                if (context && _.isFunction(context.trigger)) context.trigger('request', context, xhr, options);
            };

            options.success = function(resp) {
                // parse the data here
                EverTrue.Parser( resp, null, function(responseData, pagingData) {
                    if (success) {
                        success(responseData, resp, options)
                    };
                    if (context && _.isFunction(context.trigger)) {
                        context.trigger('success', context, resp, options);
                    }
                });
                promise.resolve(resp);
            };

            options.timeout = 15000;
            var error = options.error;
            options.error = function(xhr, textStatus, errorThrown) {
                if (urlHelper.isAuthenticatedOptions(options) && xhr.status == 401) {
                    EverTrue.Session.renew();
                    EverTrue.Session.enqueue(options);
                } else {
                    if (context && _.isFunction(context.trigger)) context.trigger('error', context, xhr, options);
                    if (error && _.isFunction(error)) error(xhr, options);
                    // trigger a global error
                    EverTrue.vent.trigger('apiError', options, xhr, textStatus, errorThrown);
                }
                promise.fail(errorThrown);
            };

            /*
             * Browser Compatability:
             * Explicitly set dataType to prevent browsers (such as Firefox)
             * from making assumptions and reading the wrong data type.
             * This issue persists despite the API returning the proper content/type.
             */

            // not sure if removing this will mess up firefox, but the auth
            // endpoint wouldn't accept this contentType for some reason
            // we can always conditionally check for firefox?

            if (urlHelper.isAuthenticatedOptions(options)) {
                EverTrue.Session.enqueue(options);
            } else {
                $.ajax(options);
            }
            return promise;
        },

        buildBaseURL: function (path, param_objs, extra) {
            var param_text = (param_objs) ? ($.param(param_objs)) : "",
                extra_param = (extra) ? extra : "",
                url =  path + "?" + param_text + extra_param;
            return url;
        },

        // Wrap all parseJSON calls in try catch
        jsonParse: function(data, fail_default) {
            var resp = "";
            try {
                resp = $.parseJSON(data);
            } catch (error) {
                resp = (fail_default) ? fail_default : data;
            }
            return resp;
        },

        // find in array
        findInArray : function (field_name, array, val){
            var value = val || "value",
                find = _.findWhere(array, {name: field_name});

            return find ? find[value] : "";
        },

        withinRange: function(number, min, max) {
            return Math.min(Math.max(min, number), max);
        },

        randomKey: function(id) {
            var key = Math.round(Math.random() * 100000);
            if (id) {
                key = key + "_" + id;
            }
            return key;
        },

        arrayClone: function(array) {
            return _.map(array, function(obj){
                return _.clone(obj);
            });
        },

        cloneData: function(item) {
            if (_.isArray(item)) {
                return _.map(item, this.cloneData);
            } else if (_.isObject(item)) {
                return _.mapObject(item, this.cloneData);
            } else {
                return item;
            }
        },

        // Returns true if values are set in an object
        valuesInObject : function(obj){
            var vals = _.values(obj),
                val_exists = false;

            _.each(vals, function(val){
                //if the value is not null, or if the contained object is not empty, return true
                if ( (!_.isObject(val) && val) || (_.isObject(val) && !_.isEmpty(val)) ) {
                    val_exists = true;
                }
            });
            return val_exists;
        },

        // If an object contains an object, recursively call this function until all contained objects
        // are in one dimension
        expandObject : function(obj) {
            var view = this,
                newObj = _.clone(obj);

            _.each(newObj, function(value, key){
                if (_.isObject(value)) {
                    newObj = _.omit(newObj, key);
                    newObj = _.extend(newObj, view.expandObject(value));
                }
            });
            return newObj;
        },

        capFirst: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },

        Parser: function ( resp, xhr, callback ) {
            if (resp) {
                // if we are dealing with an EverTrue api response envelope
                if (resp.meta && resp.response) {
                    if (resp.meta) {
                        if (resp.meta.status == "ok" && resp.response.data){
                            var data = resp.response.data;
                            var paging = resp.response.paging;

                            if ( _.isFunction(callback)) {
                                callback(data, paging);
                            } else {
                                return data;
                            }
                        } else if (resp.meta.status !== "ok") {
                            throw new Error(!!resp.meta.message ? resp.meta.message : "error:  bad response");
                        }
                    }
                } else if (_.isFunction(callback)) {
                    callback(resp);
                } else {
                    return resp;
                }
            }
            else if (_.isFunction(callback)) {
                callback();
            }
        },

        // overriding sync to use local storage when possible
        sync : function(method, model, options) {
            var key = this.urlRoot;

            if (this instanceof Backbone.Collection) {
                key += '_collection';
                // default to using "reset" instead of "set" until we update our
                // code to leverage Backbone 1.0's "set" feature on collections
                if (!options.set) options.reset = true;
            }

            if (key) {
                var success = options.success;
                var error = options.error;
                // backbone's wrapError should take care of notifying the models,
                // but lets handle the global error
                options.error =  function(xhr, textStatus, errorThrown) {
                    if (error) error(xhr, options);
                    EverTrue.vent.trigger('apiError', options, xhr, textStatus, errorThrown);
                };
                if (method === 'read' && !options.forceUpdate && this.useLocalStorage !== false) {
                    // make a network request and store result in local storage
                    var data;
                    if (this.getFromStorage) {
                        data = this.getFromStorage();
                    } else {
                        EverTrue.amplify(key);
                    }
                    if (data) {
                        // provide data from local storage instead of a network call
                        // simulate a normal async network call
                        setTimeout(function(){
                            success(data, 'success', null);
                        }, 0);
                    }
                }
                if (!options.localOnly) {
                    options.success = function(resp, status, xhr) {
                        success(resp, status, xhr);
                    };
                    // call normal backbone sync
                    return Backbone.sync(method, model, options);
                }
            }
        },
        auth: {isRenewing: false},

        logout : function(options) {
            options = options || {};
            var timeout = 500;
            if (_.isFinite(options.timeout)) {
                timeout = options.timeout;
            }
            if (options.killPrimeToken) {
                EverTrue.api("skiff", {
                    type: "DELETE",
                    urlOverride: {params: {auth_provider: null, auth: null}},
                    xhrFields: {withCredentials: true},
                    complete: _.delay(function() {
                        Backbone.history.navigate("/login");
                        window.location.reload();
                    }, timeout)
                });
            } else {
                _.delay(function() {
                    Backbone.history.navigate("/login");
                    window.location.reload();
                }, timeout)
            }
            EverTrue.vent.trigger("closeOrgNav");
            EverTrue.erase();
        },

        isStandard : function(){
            var products = EverTrue.DNA.get("ET.Org.Products");
            var community = (products) ? _.findWhere(products, {name: "community"}) : "";
            if (!_.isEmpty(community) && (community.premium == true) ){
                return false;
            } else {
                return true;
            }
        },

        isGivingTreeOnly : function () {
            var products = EverTrue.DNA.get("ET.Org.Products");
            var community  = (products) ? _.findWhere(products, {name: "community"}) : "";
                givingTree = (products) ? _.findWhere(products, {name: "givingtree"}) : "";

            return (_.isEmpty(community) && !_.isEmpty(givingTree));
        },


        // Wrapper function for amplify on the EverTrue object
        amplify: function(key, value, forceKey) {
            key = this.namespaceStorageKeys(key, forceKey);
            try {
                if (typeof value !== "undefined") {
                    return amplify.store(key, value);
                } else {
                    return amplify.store(key);
                }
            }
            // local storage has a limit on bytes stored. if we hit that limit, clear out all non-session based
            // data in storage
            catch (e) {
                if (e === "amplify.store quota exceeded") {
                    EverTrue.clearStorage();
                }
            }

        },

        namespaceStorageKeys : function(key, forceKey){
            // the organization and organizations keys are the only key that does not get namespaced.
            // The user can only be logged into one oid at the time, and the value of this key represents
            // the current organization the user is logged into.
            //
            //
            // other than the organization key, lets namespace all keys with the following convention
            // <app-id>:user:<user-id>:<key-name>
            // this convention is what linkedin uses :
            // http://engineering.linkedin.com/mobile/linkedin-ipad-using-local-storage-snappy-mobile-apps
            //
            // local storage is already sandboxed by domains so stage, dev, prod collisions are avoided

            if (key !== 'organization' && key !== 'organization_collection' && !forceKey){
                var namespace = '';
                // namespace the localstorage key with the oid
                namespace = (EverTrue.Organization) ? EverTrue.Organization.get('id') : namespace;
                // namespace with user-id
                // need session key to get user-id
                if (key !== 'session' && key !== 'auth/session' && key !== 'dna' && key !== 'user'){
                    namespace = (EverTrue.User) ? namespace + ':' + EverTrue.User.id : namespace;
                }
                key = namespace + ':' + key;
            }
            return key;
        },

        clearStorage : function ( keysToLeave, hard) {
            var store = amplify.store();
            if (!keysToLeave) {
                // use default keys to leave
                var oidKey = (EverTrue.Organization) ? EverTrue.Organization.get('id') : '';
                    keysToLeave = [
                        'client',
                        'organization',
                        oidKey + ':user',
                        oidKey + ':session',
                        oidKey + ':dna',
                        oidKey + ':has_admin_login',
                        'has_admin_login'
                    ];
            }

            for ( var key in store ) {
                // -1 means its not in the array
                if ( hard || $.inArray( key, keysToLeave ) === -1)
                {
                    amplify.store( key, null );
                }
            }
        },

        getQueryStringHash : function ( query_param ) {
            var query = query_param || window.location.search;
            if (!query) return;

            var query_string = {};


            // when "?" is the first char, get rid of it
            if ( query.substr(0,1) === '?' )
                query = query.substr(1);

            var vars = query.split("&");

            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].replace("=", "|").split("|"); //using replace will only replace first instance of =, which solves bug when == in token
                pair[0] = decodeURIComponent(pair[0]);
                pair[1] = decodeURIComponent(pair[1]);
                // If first entry with this name
                if (typeof query_string[pair[0]] === "undefined") {
                    query_string[pair[0]] = pair[1];
                    // If second entry with this name
                } else if (typeof query_string[pair[0]] === "string") {
                    var arr = [ query_string[pair[0]], pair[1] ];
                    query_string[pair[0]] = arr;
                    // If third or later entry with this name
                } else {
                    query_string[pair[0]].push(pair[1]);
                }
            }

            return query_string;
        },

        isValidOID: function (oid) {
            var reg = new RegExp("#^[a-f]+$#i");
            return reg.test(oid);
        },

        getParameterByName : function ( name, query_param ) {
            var param = null;
            var query = query_param || window.location.search;
            var hash = this.getQueryStringHash( query );
            if (hash) {
                param = hash[name];
            }
            return param;
        },

        // function to get the value of an object at a variable level with a string such as
        // path = "level1.level2.blah"
        useValueFromVariableKeyWithDotNotation : function(path,obj,value){
            // if the key has dot notation but does not actually map to the object we wrap the key in brackets like [Blah.blah.blah] need to just neet to extract the key from the brackets and get its value.
            var rootObj = obj;
            var p = path;
            var root = false;
            p = p.split('.');

            // sometimes we use dot notation in our keys so if there is not a nested object for the dot notation, we should try to fallback to the key
            for (var i = 0, len = p.length; i < len - 1; i++){
                if(obj){
                    obj = obj[p[i]];
                }
                else{
                    root = true;
                    break;
                }
                if (!obj){
                    root = true;
                    break;
                }
            }
            if(value){
                return (root) ? rootObj[path] = value : obj[p[len - 1]] = value;
            }
            else {
                return (root) ? rootObj[path] : obj[p[len - 1]];
            }
        },

        ensureExists : function(elementFunction, options, count){
            options = options || {};

            count = count || 0;
            count += 10;

            var element = elementFunction();
            if(element){
                if(_.isFunction(options.success)) {
                    options.success();
                }
                else{
                    return element;
                }
            }
            else{
                //stop after 5s
                if (count < 5000){
                    setTimeout(function(){
                        EverTrue.ensureExists(elementFunction, options, count);
                    }, 5);
                }
                else{
                    if(_.isFunction(options.error)) {
                        options.error();
                    }
                }
            }
        },

        // Extends mixins within coffeescript classes
        include: function(mixins) {
            var self = this;
            _.each(mixins, function(mixin) {
                _.each(mixin, function(value, key) {
                    if (key != "included") {
                        self.prototype[key] = value;
                    }
                });

                var include = mixin.included;
                if (include) include.apply(self);
            });
        },

        regexEscape : function(text) {
            return text.replace("/[-[\]{}()*+?.,\\^$|#\s]/g", "\\$&");
        },

        toCamelCase: function(str) {
            return str.replace(/(?:^|\s)\w/g, function(match) {
                return match.toUpperCase();
            });
        },

        isArrayEqual: function(array1, array2) {
            if ((array1 != null ? array1.length : void 0) !== (array2 != null ? array2.length : void 0)) {
                return false;
            } else if (!_.isEmpty(_.difference(array1, array2))) {
                return false;
            } else if (!_.isEmpty(_.difference(array2, array1))) {
                return false;
            } else {
                return true;
            }
        },

        fetchTemplate : window.fetchTemplate || null,

        // Suppression bits
        // https://github.com/evertrue/core/blob/8de8f4cd53cea8190731ce28724ecf04022f19f4/include/config.php
        SUPPRESSION_FLAG: 239
    };

    return EverTrue;
});

